let dict = {
  receiveStatus:{
    1: '接受报价',
    2: '关闭报价'
  }
}
export default dict